const STRINGS_KEYS = {
  DIRECT: 'falcon_de_direct',
  GET_PRICES: 'falcon_de_get_prices',
  INDIRECT: 'falcon_de_indirect',
  FLIGHTS: 'falcon_de_flights',
  FLIGHTS_FROM: 'falcon_de_flights_from',
  TRANSPORT: 'falcon_de_transport',
  FROM_PRICE: 'falcon_de_from_price',
  FLIGHTS_TO_COUNTRY_TITLE: 'falcon_de_flights_to_country_title',
  SEE_FEWER_DESTINATIONS: 'falcon_de_see_fewer_destinations',
  SEE_MORE_DESTINATIONS: 'falcon_de_see_more_destinations',
} as const;

export const DEFAULT_STRINGS = {
  falcon_de_direct: 'Direct',
  falcon_de_flights: 'flights',
  falcon_de_flights_from: 'flights-from',
  falcon_de_from_price: 'From @@price@@',
  falcon_de_get_prices: 'Get prices',
  falcon_de_indirect: '1+ stops',
  falcon_de_transport: 'transport',
  falcon_de_flights_to_country_title: 'Where to go in @@country@@',
  falcon_de_see_fewer_destinations: 'See less',
  falcon_de_see_more_destinations: 'See more destinations',
};

export const DEFAULT_IMAGE_URL =
  'https://content.skyscnr.com/5b4d472e7614d0edb01952574069c6c8/fillter-illu.svg';

export const DIRECTNESS: { [key: string]: string } = {
  DIRECT: 'DIRECT',
  INDIRECT: 'INDIRECT',
  UNKNOWN: 'UNKNOWN',
};

export default {
  STRINGS: STRINGS_KEYS,
};

export const DESTINATIONS = [
  {
    name: 'Chongqing',
    imageUrl:
      'https://content.skyscnr.com/e23c1ef48a2ade5f7e9e9cf254413587/GettyImages-476702314.jpg',
    destinationId: 'CCKG',
    direct: 'INDIRECT',
    price: '£270',
    rawPrice: 270,
    outboundDate: '2023-10-25',
    inboundDate: '2023-10-28',
  },
  {
    name: 'Shanghai',
    imageUrl:
      'https://content.skyscnr.com/c10d466e9ded52fcd9d103fa6e7b4e92/stock-photo-shanghai-in-blue-32506683.jpg',
    destinationId: 'CSHA',
    direct: 'INDIRECT',
    price: '£318',
    rawPrice: 318,
    outboundDate: '2023-10-25',
    inboundDate: '2023-10-28',
  },
  {
    name: 'Beijing',
    imageUrl:
      'https://content.skyscnr.com/ec6e1a573dde92117986911e9c097f0b/GettyImages-462416635.jpg',
    destinationId: 'BJSA',
    direct: 'INDIRECT',
    price: '£341',
    rawPrice: 341,
    outboundDate: '2023-10-25',
    inboundDate: '2023-10-28',
  },
];

export const DESTINATIONS_WITH_COUNTRY_NAME = DESTINATIONS.map((d) => ({
  ...d,
  countryName: 'China',
}));
